module.exports = __webpack_public_path__ + "static/media/MainCover.1b2ce6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/profile/MainCover.png
// module id = 322
// module chunks = 0